module.exports = __webpack_public_path__ + "img/bingo_ball-78.be4cbf5e.png";